import { useState, useEffect } from 'react';

export function usePersistedColumns(key: string, defaultColumns: string[]) {
  const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      }
      return defaultColumns;
    } catch (error) {
      console.error('Error reading columns from localStorage:', error);
      return defaultColumns;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(visibleColumns));
    } catch (error) {
      console.error('Error saving columns to localStorage:', error);
    }
  }, [key, visibleColumns]);

  return [visibleColumns, setVisibleColumns] as const;
}
